export default class CsvImportService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  /**
   * CSV-Import von Kunden (Format: csv-import.md im Backend-Repository).
   * Liefert { dryRun, total, created, updated, columns, errors } – bei Fehlern (HTTP 400) mit gefüllter errors-Liste, dann wurde nichts gespeichert.
   */
  async importCustomers(file, options) {
    return await this.upload('customers', file, options)
  }

  /** CSV-Import von Lieferanten, Rückgabe wie importCustomers. */
  async importSuppliers(file, options) {
    return await this.upload('suppliers', file, options)
  }

  async upload(kind, file, options) {
    const formData = new FormData()
    formData.append('file', file, file.name)

    const response = await fetch(`${this.baseUrl}/csvImport/${kind}?dryRun=${options.dryRun ? 'true' : 'false'}`, {
      body: formData,
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'POST'
    })

    if (response.status === 200 || response.status === 400) {
      return await response.json()
    }

    const error = new Error(`HTTP ${response.status}`)
    error.status = response.status

    throw error
  }
}
